function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import debounce from 'lodash.debounce';
import { vsFilter, dhFilterFilled } from '@deephaven/icons';
import "./FilterInputField.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@deephaven/components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * An input field showing a input field and button.
 * Debounces changes.
 */
class FilterInputField extends PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "inputField", void 0);
    _defineProperty(this, "initialValue", void 0);
    _defineProperty(this, "debouncedSendUpdate", void 0);
    var debounceMs = props.debounceMs;
    this.debouncedSendUpdate = debounce(this.sendUpdate.bind(this), debounceMs);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCommit = this.handleCommit.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleContextMenu = this.handleContextMenu.bind(this);
    this.inputField = null;
    var value = props.value;
    this.initialValue = value;
    this.state = {
      isChanged: false,
      value
    };
  }
  componentDidMount() {
    var _this$inputField;
    (_this$inputField = this.inputField) === null || _this$inputField === void 0 || _this$inputField.focus();
  }
  componentDidUpdate(prevProps) {
    var debounceMs = this.props.debounceMs;
    if (prevProps.debounceMs !== debounceMs) {
      this.debouncedSendUpdate.flush();
      this.debouncedSendUpdate = debounce(this.sendUpdate.bind(this), debounceMs);
    }
  }
  componentWillUnmount() {
    this.debouncedSendUpdate.cancel();
  }
  // clear filters needs to be able to reset the value externally
  // and due to the way this component handles its own debouncing
  // this was easier than moving state up.
  setValue(value) {
    this.initialValue = value;
    this.setState({
      value
    });
  }
  focus() {
    var _this$inputField2;
    (_this$inputField2 = this.inputField) === null || _this$inputField2 === void 0 || _this$inputField2.focus();
  }
  handleChange(event) {
    var value = event.target.value;
    this.setState({
      value,
      isChanged: true
    });
    this.debouncedSendUpdate(value);
  }
  handleCancel() {
    this.debouncedSendUpdate.cancel();
    var initialValue = this.initialValue;
    var isChanged = this.state.isChanged;
    if (isChanged) {
      this.sendUpdate(initialValue);
    }
    var onDone = this.props.onDone;
    onDone();
  }
  handleCommit() {
    var setGridFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var defocusInput = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    this.debouncedSendUpdate.flush();
    var onDone = this.props.onDone;
    onDone(setGridFocus, defocusInput);
  }
  handleFocus() {
    var _this$inputField3;
    (_this$inputField3 = this.inputField) === null || _this$inputField3 === void 0 || _this$inputField3.select();
  }
  handleBlur(event) {
    var relatedTarget = event.relatedTarget;
    // handleCommit results in a call that steals focus
    if (relatedTarget != null && relatedTarget.classList.contains('context-menu-container')) {
      // input blurred by calling context-menu
      // don't set grid focus, but do null column focus
      this.handleCommit(false, true);
    } else if (relatedTarget != null && relatedTarget.classList.contains('advanced-filter-button')) {
      // blurred by clicking an advanced filter button
      // don't set grid focus, maintain focusedFilterBarColumn state
      this.handleCommit(false, false);
    } else {
      // clear both, blurred elsewhere
      this.handleCommit(true, true);
    }
  }
  handleTab() {
    var backward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    this.debouncedSendUpdate.flush();
    var onTab = this.props.onTab;
    onTab(backward);
  }
  handleKeyDown(event) {
    switch (event.key) {
      case 'Escape':
        event.stopPropagation();
        event.preventDefault();
        this.handleCancel();
        break;
      case 'Enter':
        event.stopPropagation();
        event.preventDefault();
        this.handleCommit();
        break;
      case 'Tab':
        event.stopPropagation();
        event.preventDefault();
        this.handleTab(event.shiftKey);
        break;
      default:
        break;
    }
  }
  handleContextMenu(event) {
    var onContextMenu = this.props.onContextMenu;
    onContextMenu(event);
  }
  sendUpdate(value) {
    var onChange = this.props.onChange;
    onChange(value);
  }
  render() {
    var _this$props = this.props,
      className = _this$props.className,
      style = _this$props.style,
      showAdvancedFilterButton = _this$props.showAdvancedFilterButton,
      isAdvancedFilterSet = _this$props.isAdvancedFilterSet,
      onAdvancedFiltersTriggered = _this$props.onAdvancedFiltersTriggered;
    var value = this.state.value;
    return /*#__PURE__*/_jsxs("div", {
      style: style,
      className: "iris-grid-input-autosized-wrapper",
      "data-value": value // used by css based autosizer
      ,
      children: [/*#__PURE__*/_jsx("input", {
        ref: inputField => {
          this.inputField = inputField;
        },
        className: classNames('iris-grid-input-field', className),
        type: "text",
        value: value,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onChange: this.handleChange,
        onKeyDown: this.handleKeyDown,
        onContextMenu: this.handleContextMenu,
        autoComplete: "off",
        autoCorrect: "off",
        autoCapitalize: "off",
        spellCheck: "false"
      }), showAdvancedFilterButton && /*#__PURE__*/_jsx("div", {
        className: "advanced-filter-button-container",
        children: /*#__PURE__*/_jsx(Button, {
          kind: "ghost",
          className: classNames('btn-link-icon advanced-filter-button', {
            'filter-set': isAdvancedFilterSet
          }),
          onClick: onAdvancedFiltersTriggered,
          onContextMenu: this.handleContextMenu,
          children: /*#__PURE__*/_jsxs("div", {
            className: "fa-layers ",
            children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
              icon: dhFilterFilled,
              className: "filter-solid"
            }), /*#__PURE__*/_jsx(FontAwesomeIcon, {
              icon: vsFilter,
              className: "filter-light"
            })]
          })
        })
      })]
    });
  }
}
_defineProperty(FilterInputField, "defaultProps", {
  style: {},
  className: '',
  value: '',
  showAdvancedFilterButton: false,
  isAdvancedFilterSet: false,
  onAdvancedFiltersTriggered: () => undefined,
  onChange: () => undefined,
  onDone: () => undefined,
  onTab: () => undefined,
  onContextMenu: () => undefined,
  debounceMs: 150
});
export default FilterInputField;
//# sourceMappingURL=FilterInputField.js.map